<template>
    <el-col>
        <div >
            <el-menu router mode="horizontal" :default-active="initPath" >
                <el-menu-item :index="basePath+'Module'">模块设置</el-menu-item>
                <el-menu-item :index="basePath+'Category'">产品分类管理</el-menu-item>
                <el-menu-item :index="basePath+'Dictionary'">数据字典管理</el-menu-item>
            </el-menu>
        </div>
        <router-view/>
    </el-col>
</template>

<script>
    export default {
        name: "SaleJC",
        components: {},
        data() {
            return {
                basePath:'/System/Setting/',
								initPath: window.location.href.split('#')[1]
            }

        },
        mounted() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>